module.exports = __webpack_public_path__ + "02_bob_black.df8e812c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/02_bob_black.png
// module id = 5jjE
// module chunks = 0